const RESOURCE_TABLE_COLUMN_IDS = [
  "preview",
  "name",
  "modifiedAt",
  "createdAt",
  "size",
  "kind",
  "createdBy",
  "comments",
  "tags",
  "url"
];

export { RESOURCE_TABLE_COLUMN_IDS };
//# sourceMappingURL=resourceListViewPreferences.js.map
